import { Collection } from 'vue-mc'
import { Request } from '@/http'

class BaseCollection extends Collection {
    getRequest(config) {
        return new Request(config)
    }

    request(config, onRequest, onSuccess, onFailure) {
        return super.request(config, onRequest, onSuccess, onFailure)
    }

    routes() {
        return {
            fetch: '/resource/' + this.getResourceName(),
            search: '/resource/' + this.getResourceName() + '/search',
            //save: '/resource/' + this.resourceName() +'/save',
            //delete: '/resource/' + this.resourceName() +'/delete',
        }
    }

    // paginatedSearch(q) {
    //     this.setOption('query.searchquery', q)
    //     // console.log('params', this.getFetchQuery())
    //     let method = 'GET'
    //     let route = this.getRoute('search')
    //     let url = this.getURL(route)
    //     let params = this.getFetchQuery()
    //     let config = { method, url, params }
    //     // console.log('config', config)
    //     return this.getRequest(config)
    //         .send()
    //         .then(response => {
    //             var models = this.getModelsFromResponse(response)
    //             // Append via pagination.
    //             if (this.isPaginated()) {
    //                 this.applyPagination(models)
    //                 // Replace all current models with the fetched ones.
    //             } else {
    //                 this.replace(models)
    //             }
    //             this.emit('search', { error: null })
    //             return response
    //         })
    //         .catch(error => {
    //             // console.log('error', error)
    //         })
    // }

    setIncludes(include) {
        this.setOption('query.include', include)
        return this
    }

    setPage(page) {
        this.setOption('query.page', page)
        return this
    }

    setPageSize(num) {
        this.setOption('query.pageSize', num)
        return this
    }

    setPerPage(num) {
        console.warn('DEPRECTAED setPerPage, use setPageSize instead')
        return this.setPageSize(num)
    }

    setFilter(filter) {
        this.setOption('query.filter', filter)
        return this
    }

    setResourceName(name) {
        this.resourceName = name
        return this
    }

    getResourceName() {
        if (typeof this.resourceName == 'undefined') {
            console.warn('Guessing resourcename! Should be set.')
            return this.constructor.name.toLowerCase()
        }

        if (typeof this.resourceName == 'function') {
            return this.resourceName()
        }

        return this.resourceName
    }

    setWhereHas(wherehas) {
        this.setOption('query.whereHas', wherehas)
        return this
    }

    setFields(fields) {
        this.setOption('query.fields', fields)
        return this
    }

    setFilters(filters) {
        // Reset existing filters
        this.setOption('query.filter', null)
        this.setOption('query.filter', filters)
        return this
    }

    getFetchQuery() {
        return this.getOption('query')
    }

    findOrCreate(where) {
        let model = this.find(where)

        // Return group if found
        if (model) {
            return model
        }
        // Return empty model
        return this.createModel(where)
    }

    getPaginationOptions() {
        return this.getOption('pagination')
    }

    setPaginationOptions(options) {
        this.setOption('pagination', options)
    }

    getModelsFromResponse(response) {
        let data = response.getData()

        let pagination = response.getPagination()

        console.log('getPagination', response.getPagination())

        this.setPaginationOptions(pagination)

        let models = data.data
        this.setPerPage(data.perPage).setPage(data.page)

        return models
    }
}

export { BaseCollection }
